import React from 'react';
import ProjectWizard from '@components/project/projectWizard';

const Project = ({ permissions }) => {
	return (
		<div id="project" className="megaContent">
			<div className="container-fluid">
				<ProjectWizard permissions={permissions} />
			</div>
		</div>
	);
};

export default Project;
